// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApitypesCloudProvider } from './ApitypesCloudProvider';
import {
  ApitypesCloudProviderFromJSON,
  ApitypesCloudProviderFromJSONTyped,
  ApitypesCloudProviderToJSON,
  ApitypesCloudProviderToJSONTyped,
} from './ApitypesCloudProvider';

/**
 *
 * @export
 * @interface ApitypesServiceCost
 */
export interface ApitypesServiceCost {
  /**
   *
   * @type {string}
   * @memberof ApitypesServiceCost
   */
  cloudHostID?: string;
  /**
   *
   * @type {ApitypesCloudProvider}
   * @memberof ApitypesServiceCost
   */
  cloudProvider?: ApitypesCloudProvider;
  /**
   *
   * @type {number}
   * @memberof ApitypesServiceCost
   */
  cost?: number;
  /**
   *
   * @type {string}
   * @memberof ApitypesServiceCost
   */
  dateIncurred?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesServiceCost
   */
  serviceDescription?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesServiceCost
   */
  serviceID?: string;
}

/**
 * Check if a given object implements the ApitypesServiceCost interface.
 */
export function instanceOfApitypesServiceCost(
  value: object,
): value is ApitypesServiceCost {
  return true;
}

export function ApitypesServiceCostFromJSON(json: any): ApitypesServiceCost {
  return ApitypesServiceCostFromJSONTyped(json, false);
}

export function ApitypesServiceCostFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesServiceCost {
  if (json == null) {
    return json;
  }
  return {
    cloudHostID: json['cloudHostID'] == null ? undefined : json['cloudHostID'],
    cloudProvider:
      json['cloudProvider'] == null
        ? undefined
        : ApitypesCloudProviderFromJSON(json['cloudProvider']),
    cost: json['cost'] == null ? undefined : json['cost'],
    dateIncurred:
      json['dateIncurred'] == null ? undefined : json['dateIncurred'],
    serviceDescription:
      json['serviceDescription'] == null
        ? undefined
        : json['serviceDescription'],
    serviceID: json['serviceID'] == null ? undefined : json['serviceID'],
  };
}

export function ApitypesServiceCostToJSON(json: any): ApitypesServiceCost {
  return ApitypesServiceCostToJSONTyped(json, false);
}

export function ApitypesServiceCostToJSONTyped(
  value?: ApitypesServiceCost | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloudHostID: value['cloudHostID'],
    cloudProvider: ApitypesCloudProviderToJSON(value['cloudProvider']),
    cost: value['cost'],
    dateIncurred: value['dateIncurred'],
    serviceDescription: value['serviceDescription'],
    serviceID: value['serviceID'],
  };
}
